import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivityI, TaskI} from "../../../../infrastructure/interfaces/task.interface";

@Component({
  selector: 'app-dictation',
  templateUrl: './dictation.component.html',
  styleUrls: ['./dictation.component.scss']
})
export class DictationComponent implements  OnInit, OnChanges{

  @Input() task: TaskI | null = null;
  @Input() activity: ActivityI | null = null;


  ngOnInit() {
    console.log("Dictation Task => ", this.task);
    console.log("Dictation Activity => ", this.activity)
  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
